<template>
  <div :class="[ fonstSize ,'weight-500 flex-row items-center text-text3 gap-4']">
    <template v-for="(item, index) in list" :key="index">
      <router-link v-if="item.to" :to="item.to">
        {{ item.label }}
      </router-link>
      <span v-else class="text-text1">{{ item.label }}</span>
      <SvgIcon v-if="index < list.length - 1" :icon="separatorIcon" :style="{width: '1em', height: '1em'}" />
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  size: {
    validator(value: string) {
      return ['large', 'default', 'small'].indexOf(value) > -1;
    },
    type: String,
    default: 'default'
  },
  list: {
    type: Array,
    default: () => []
  },
  separatorIcon: {
    type: String,
    default: 'Icon-Default-Arrow_Right'
  }
});

const fonstSize = computed(() => {
  switch (props.size) {
  case 'large':
    return 'f18';
  case 'small':
    return 'f14';
  default:
    return 'f16';
  }
});
</script>